import { loadModules } from 'esri-loader';
export function GeometryEngineTask(config) {
    return new Promise((resolve, reject) => {
        if (!loadModules) {
            reject('GeometryEngineTask: ArcGIS API is not loaded');
            return;
        }
        GeometryEngineTaskExecute(config).then(
            response => {
                resolve(response);
            },
            error => {
                reject(error);
            }
        );
    });
};

function GeometryEngineTaskExecute(config) {
    return new Promise((resolve, reject) => {
        loadModules([
            "esri/geometry/geometryEngine",
            "esri/geometry/projection"
        ]).then(([geometryEngine, projection]) => {
            switch (config.type) {
                case "union":
                    UnionTaskExecute(projection, geometryEngine, config, resolve, reject);
                    break;
                case "buffer":
                    BufferTaskExecute(projection, geometryEngine, config, resolve, reject);
                    break;
                case "project":
                    ProjectionTaskExecute(projection, config, config.geometries, resolve, reject);
                    break;
                case "length":
                    LengthTaskExecute(geometryEngine, config, config.geometries, resolve, reject).then(
                        lengthResponse => {
                            resolve(lengthResponse);
                        }, lengthError => {
                            reject({ "error": lengthError });
                        });
                    break;
                case "validateBussinessRules":
                    ValidateBussinessRulesTaskExecute(geometryEngine, config, config.geometries, resolve, reject);
                    break;
                case "validateBussinessRulesDistanceBetweenGeoms":
                    validateBussinessRulesDistanceBetweenGeomsTaskExecute(geometryEngine, config, config.geometries, resolve, reject);
                    break;
                case "validateSegmentCount":
                    validateSegmentCount(geometryEngine, config, config.geometries, resolve, reject);
                    break;
                case "unionpointzoom":
                    UnionTaskExecutePointZoom(projection, geometryEngine, config, resolve, reject);
                    break;
                case "centergeometry":
                    CenterGeometryTaskExecute(projection, geometryEngine, config, resolve, reject);
                    break;
                case "geomfullextent":
                    GetGraphicsExtent(projection, geometryEngine, config, resolve, reject);
                    break;
                default: break;
            }
        });
    });
}


export function RequestTaskExecute(config) {
    return new Promise((resolve, reject) => {
        loadModules([
            "esri/request","esri/identity/IdentityManager"
        ]).then(([esriRequest, IdentityManager]) => {
            switch (config.type) {
                case "Info":
                    InfoTaskExecute(esriRequest, config, resolve, reject);
                    break;
                case "layerinfo":
                    LayerInfoTaskExecute(esriRequest, config, resolve, reject, IdentityManager);
                    break;
                case "layerFieldsInfo":
                    LayerFieldsInfoTaskExecute(esriRequest, config, resolve, reject);
                    break;
                case "Validatelayerinfo":
                    ValidatelayerinfoTaskExecute(esriRequest, config, resolve, reject);
                    break;
                default: break;
            }
        });
    });
}

/*
 * //Usage
 GeometryEngineTask({ "geometries": geom, "spatialReference": spatialReference, "type": "project" })
 * geometryEngine of esri/geometry/geometryEngine
 * config of union task requires geometries and type
 * resolve resolve of Promise
 * reject resolve of reject
 */
function ProjectionTaskExecute(projection, config, geometry, resolve, reject) {
    try {
        if (config && config.spatialReference) {
            //console.log('spatialReference......',config.spatialReference)
            let projectionPromise = projection.load();
            projectionPromise.then(
                response => {
                    //console.log('spatialReference......',config.spatialReference)
                    const projectedgeom = projection.project(geometry, config.spatialReference);
                    resolve(projectedgeom);
                },
                error => {
                    reject(error);
                });
        } else {
            reject({ "error": "Invalid geometries" });
        }
    } catch (error) {
        reject({ "error": error });
    }
}


/*
 * //Usage
 *  GeometryEngineTask({ "geometries": geometries, "type": "union" }).then(
    GeomEngineresponse => {
    if (GeomEngineresponse && GeomEngineresponse.centroid)
    CenterAndZoom(view, GeomEngineresponse.centroid, inThis.props.options.viewProperties.zoom);
    },
    GeomEngineerror => {
    console.log(GeomEngineerror);
    });
 * geometryEngine of esri/geometry/geometryEngine
 * config of union task requires geometries and type
 * resolve resolve of Promise
 * reject resolve of reject
 */
function UnionTaskExecute(projection, geometryEngine, config, resolve, reject) {
    try {
        //Check fo not null geoms
        //let configgeom = config.geometries.filter(a => a.geometry != null);
        if (config && config.geometries) {
            let union = geometryEngine.union(config.geometries);
            if (config.spatialReference)
                ProjectionTaskExecute(projection, config, union, resolve, reject);
            else
                resolve(union);
        } else {
            reject({ "error": "Invalid geometries" });
        }
    } catch (error) {
        reject({ "error": error });
    }
}

/*
 *  //Usage
      GeometryEngineTask({ "geometries": geometries, "type": "buffer", "distance": "10", "unit": "miles"  }).then(
        GeomEngineresponse => {
            let g=new Graphic(GeomEngineresponse[0]);
            g.symbol= inThis.mapConstants.PolygonFillSymbol;
            layer.graphics.add(g);
            if (GeomEngineresponse && GeomEngineresponse)
                CenterAndZoom(view, GeomEngineresponse, inThis.props.options.viewProperties.zoom);
        },
        GeomEngineerror => {
            console.log(GeomEngineerror);
        });
 * geometryEngine of esri/geometry/geometryEngine
 * config of union task requires geometries, type as buffer , distance and unit
 * resolve resolve of Promise
 * reject resolve of reject
 */
function BufferTaskExecute(projection, geometryEngine, config, resolve, reject) {
    try {
        if (config && config.geometries && config.distance && config.unit) {
            let bufferGeom = geometryEngine.buffer(config.geometries, config.distance, config.unit);
            if (config.spatialReference)
                ProjectionTaskExecute(projection, config, bufferGeom, resolve, reject);
            else
                resolve(bufferGeom);
        } else {
            reject({ "error": "Invalid geometries or distance or unit" });
        }
    } catch (error) {
        reject({ "error": error });
    }
}

/*
 * //Usage
 GeometryEngineTask({ "geometries": geom, "spatialReference": spatialReference, "type": "length",units:"meters | feet | kilometers | miles | nautical-miles | yards" })
 * geometryEngine of esri/geometry/geometryEngine
 * config of union task requires geometries and type
 * resolve resolve of Promise
 * reject resolve of reject
 */
function ValidateBussinessRulesTaskExecute(geometryEngine, config, graphicies, resolve, reject) {
    try {
        if (config.MapBussinessRules) {            
        var geomLengthRules =config.MapBussinessRules.flatMap(businessRule => businessRule.rules && businessRule.rules.filter(rule => 
            rule.fields.indexOf(config.ValidateOf || "GEOMETRY_LENGTH_METERS") !== -1)
                ).filter(businessRule => businessRule);
        // config.MapBussinessRules.find(function (mr) { if (mr.fields && mr.fields.indexOf(config.ValidateOf || "GEOMETRY_LENGTH_METERS") !== -1) return mr.rules })
            let inthis = this;
            if (geomLengthRules) {
                LengthTaskExecute(geometryEngine, config, graphicies, resolve, reject).then(
                    geomEngineResponse => {
                        if (geomEngineResponse) {
                            if (geomEngineResponse.length) {
                                geomLengthRules.forEach(function (gr) {
                                    const checks = gr.check
                                    const run = gr.run
                                    let rulesResponses = [];
                                    if (checks && run && run.events) {
                                        checks.forEach(function (check) {
                                            if (check && check.rules && check.rules.length > 0) {
                                                check.rules.forEach(function (r) {
                                                    let isValidationFalied = false;
                                                    if (r.type === "=") {
                                                        isValidationFalied = geomEngineResponse.length === r.value
                                                    }
                                                    else if (r.type === ">") {
                                                        isValidationFalied = geomEngineResponse.length > r.value
                                                    }
                                                    else if (r.type === "<") {
                                                        isValidationFalied = geomEngineResponse.length < r.value
                                                    }
                                                    else if (r.type === ">=") {
                                                        isValidationFalied = geomEngineResponse.length >= r.value
                                                    }
                                                    else if (r.type === "<=") {
                                                        isValidationFalied = geomEngineResponse.length <= r.value
                                                    }
                                                    rulesResponses.push({ RuleId: gr.ruleId, IsValidationFalied: isValidationFalied, alertMessage: run.events.alertMessage });
                                                });
                                            }
                                        });
                                    }
                                    resolve(rulesResponses);
                                });
                            }
                            console.log('length sketch ------------------', geomEngineResponse)
                        }
                        resolve([]);
                    },
                    geomEngineerror => {
                        reject({ "error": geomEngineerror });
                    });
            } else {
                resolve([]);
            }
        } else {
            resolve([]);
        }
    } catch (error) {
        reject({ "error": error });
    }
}

/*
 * //Usage
 GeometryEngineTask({ "geometries": geom, "spatialReference": spatialReference, "type": "length",units:"meters | feet | kilometers | miles | nautical-miles | yards" })
 * geometryEngine of esri/geometry/geometryEngine
 * config of union task requires geometries and type
 * resolve resolve of Promise
 * reject resolve of reject
 */
function LengthTaskExecute(geometryEngine, config, geometry, resolve, reject) {
    return new Promise((Lengthresolve, Lengthreject) => {
        try {
            if (geometry && config && config.spatialReference) {
                let length = 0;
                if(config.totalGeometryLength)// Pre-calculated length
                    length = config.totalGeometryLength;
                else
                {
                    if (geometry.length > 0) {
                        geometry.forEach(geom => {
                            const templength = LengthTaskWrapper(geometryEngine, geom.geometry || geom, config.units || "feet")
                            length = parseFloat(templength) + parseFloat(length) 
                        });
                    } else {
                        let geom = geometry.length ? geometry[0] : geometry
                        length = LengthTaskWrapper(geometryEngine, geom.geometry || geom, config.units || "feet")
                    }
                }
                console.log(length)
                Lengthresolve({ "length": length });
            } else {
                Lengthreject({ "error": "Invalid geometries" });
            }
        } catch (error) {
            Lengthreject({ "error": error });
        }
    });
}

function LengthTaskWrapper(geometryEngine, geometry, unit) {
    return geometryEngine.geodesicLength(geometry, unit);
}

/*
 * //Usage
 GeometryEngineTask({ "geometries": geom, "spatialReference": spatialReference, "type": "validateBussinessRulesDistanceBetweenGeoms",units:"meters | feet | kilometers | miles | nautical-miles | yards"})
 * geometryEngine of esri/geometry/geometryEngine
 * searchRadius :The distance to search from the inputPoint in the units of the view's spatial reference.
 * config of union task requires geometries and type
 * resolve resolve of Promise
 * reject resolve of reject
 */
 function validateBussinessRulesDistanceBetweenGeomsTaskExecute(geometryEngine, config, graphicies, resolve, reject) {
    try {
        if (config.MapBussinessRules && graphicies && config && config.spatialReference && graphicies.length > 1) {
            
            var geomDistanceRules =config.MapBussinessRules.flatMap(businessRule => businessRule.rules && businessRule.rules.filter(rule => 
                rule.fields.indexOf(config.ValidateOf || "GEOMETRY_DISTANCE_BETWEEN_GEOMS_LESS_THAN_METERS") !== -1)
                ).filter(businessRule => businessRule);
            //var geomDistanceRules = config.MapBussinessRules.find(function (mr) { if (mr.fields && mr.fields.indexOf(config.ValidateOf || "GEOMETRY_DISTANCE_BETWEEN_GEOMS_LESS_THAN_METERS") !== -1) return mr.rules })
            let inthis = this;
            if (geomDistanceRules && Array.isArray(geomDistanceRules) && geomDistanceRules.length > 0) {
                geomDistanceRules.forEach(function (gr) {
                    const checks = gr.check
                    const run = gr.run
                    let rulesResponses = [];
                    if (checks && run && run.events) {
                        checks.forEach(function (check) {
                            if (check && check.rules && check.rules.length > 0) {
                                check.rules.forEach(function (r) {
                                    let primarygeom = graphicies.length ? graphicies[0] : graphicies;
                                    graphicies.shift();
                                    if (graphicies.length > 0) {
                                        graphicies.forEach(geom => {
                                            let secondgeom=geom.geometry || geom;
                                            const distanceBetween = DistanceBetweenGeomsTaskWrapper(geometryEngine, primarygeom.geometry|| primarygeom,secondgeom,config.unit || 2)
                                            let isValidationFalied = false;
                                            if (r.type === "=") {
                                                isValidationFalied = distanceBetween === r.value
                                            }
                                            else if (r.type === ">") {
                                                isValidationFalied = distanceBetween > r.value
                                            }
                                            else if (r.type === "<") {
                                                isValidationFalied = distanceBetween < r.value
                                            }
                                            else if (r.type === ">=") {
                                                isValidationFalied = distanceBetween >= r.value
                                            }
                                            else if (r.type === "<=") {
                                                isValidationFalied = distanceBetween <= r.value
                                            }
                                            rulesResponses.push({ RuleId: gr.ruleId, IsValidationFalied: isValidationFalied, alertMessage: run.events.alertMessage });
                                            
                                            console.log('Distance sketch ------------------', distanceBetween)
                                        });
                                    }          
                                });
                            }
                        });
                    }
                    resolve(rulesResponses);
                });
            } else {
                resolve([]);
            }
        } else {
            resolve([]);
        }
    } catch (error) {
        reject({ "error": error });
    }
}

function DistanceBetweenGeomsTaskWrapper(geometryEngine, primarygeom,secondgeom, unit) {
    return geometryEngine.distance(primarygeom,secondgeom, unit );
}
/*
* //Usage
*  RequestTaskExecute({ "url": serviceurl, "type": "info" }).then(
response => {
if (response){

},
error => {
console.log(error);
});
* config of union task requires serviceurl and type
* resolve resolve of Promise
* reject resolve of reject
*/
function InfoTaskExecute(esriRequest, config, resolve, reject) {
    try {
        if (config && config.url) {
            let url = ParseLayerUrl(config.url, true);
            InfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, true)
        }
    } catch (error) {
        reject({ "error": error });
    }
}

function InfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, isinfo) {
    esriRequest(url).then(
        response => {
            InfoTaskExecuteResponse(esriRequest, config, resolve, reject, response)
        },
        error => {
            if (isinfo) {
                url = ParseLayerUrl(config.url, false);
                InfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, false)
            }
            else
                reject(error);
        });
}

function InfoTaskExecuteResponse(esriRequest, config, resolve, reject, response) {
    if (response != null && response.data != null && response.data.fields != null) {
        var layerInfo = response.data.fields.map(function (f) { return { "Name": f.name, "Type": f.type } });
        resolve(layerInfo);
    } else {
        reject({ "Message": "Unable to load fields info" });
    }
}
function ParseLayerUrl(url, isinfo) {
    /*
    if (url.indexOf('/info?') === -1) {
        url = url + '/info?f=json'
        url = url.replace('/query', '/info?f=json')
            .replace('/info', '/info?f=json');
    }*/

    if (url.indexOf('/query') !== -1) {
        const urlParts = url.split('/query')
        url = urlParts[0];
    }
    if (isinfo && url.indexOf('/info?') === -1) {
        url = url + '/info?f=json'
    }
    else {
        const urlParts = url.split('/info')
        url = urlParts[0] + '?f=json'
    }
    return url;
}
function rgb2hex(rgb) {
    rgb = rgb.match(/^[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? "#" +
        ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
}


/*
* //Usage
*  RequestTaskExecute({ "url": serviceurl, "type": "layerinfo" }).then(
response => {
if (response){

},
error => {
console.log(error);
});
* config of union task requires serviceurl and type
* resolve resolve of Promise
* reject resolve of reject
*/
function LayerInfoTaskExecute(esriRequest, config, resolve, reject, IdentityManager) {
    try {
        if (config && config.url) {
            let url = ParseLayerUrl(config.url, true);
            CheckLayerHasAuthentication(url).then(response => {
                if(response){
                    if(config.token && config.expires){
                        url = url + '&token=' + config.token + '&expires=' + config.expires;
                        CheckLayerHasAuthentication(url).then(response => {
                            if(response){
                                reject({ "error": "TOKEN_REQUIRED" });
                            }else{
                                LayerInfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, true, IdentityManager)
                            }
                        })
                       
                    }else{
                        reject({ "error": "TOKEN_REQUIRED" });
                    }                    
                }else{
                    LayerInfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, true, IdentityManager)
                }
                console.log(response);
            }).catch(error => {            
                LayerInfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, true, IdentityManager)
            })            
        }
    } catch (error) {
        reject({ "error": error });
    }
}
function LayerInfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, isinfo, IdentityManager) {       
        
        esriRequest(url).then(
        response => {
            LayerInfoTaskExecuteResponse(esriRequest, config, resolve, reject, response)
        },
        error => {
            if (isinfo) {
                url = ParseLayerUrl(config.url, false);
                LayerInfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, false)
            }
            else
                reject(error);
        });

}
function LayerInfoTaskExecuteResponse(esriRequest, config, resolve, reject, response) {
    let layerInfo = {};
    if (response != null && response.data != null && response.data.fields != null && response.data.fields.length > 0) {
        layerInfo.fields = response.data.fields.map(function (f) { return { "Name": f.name, "Type": f.type } });
        layerInfo.type = response.data.type === "Feature Layer" ? "F" : "M";
        layerInfo.name = response.data.name;
        layerInfo.geometryType = response.data.geometryType;
        layerInfo.description = response.data.description;
        layerInfo.LayerColor = response.data.drawingInfo && response.data.drawingInfo.renderer
            && response.data.drawingInfo.renderer.symbol && response.data.drawingInfo.renderer.symbol.color && rgb2hex(response.data.drawingInfo.renderer.symbol.color.join(',')) //: '#ffffff'
        layerInfo.HighlightColor = layerInfo.LayerColor //|| '#ffffff'
        //   layerInfo.InfoTemplateFields = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.SelectField = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.SearchField = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.LabelExpression = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.AsofArchiveStart = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.AsofArchiveEnd = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.InfoTemplate = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.GridTemplate = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.EditorTemplate = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        layerInfo.FilterAttributes = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } }) || []
        resolve(layerInfo);
    } else {
        reject({ "Message": "Unable to load fields info" });
    }


}
//LayerFieldsInfoTaskExecute
/*
* //Usage
*  RequestTaskExecute({ "url": serviceurl, "type": "layerinfo" }).then(
response => {
if (response){

},
error => {
console.log(error);
});
* config of union task requires serviceurl and type
* resolve resolve of Promise
* reject resolve of reject
*/
function LayerFieldsInfoTaskExecute(esriRequest, config, resolve, reject) {
    try {
        if (config && config.url) {
            let url = ParseLayerUrl(config.url, true);
            LayerFieldsInfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, true);
        }
    } catch (error) {
        reject({ "error": error });
    }
}
function LayerFieldsInfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, isinfo) {
    esriRequest(url).then(
        response => {
            let layerInfo = [];
            if (response != null && response.data != null && response.data.fields != null && response.data.fields.length > 0) {
                layerInfo = response.data.fields.map(function (f) { return { "Name": f.name, "Value": f.name } });
                resolve(layerInfo);
            } else {
                reject({ "Message": "Unable to load fields info" });
            }

        },
        error => {
            if (isinfo) {
                url = ParseLayerUrl(config.url, false);
                LayerFieldsInfoTaskExecuteRequest(esriRequest, config, resolve, reject, url, isinfo)
            }
            else
                reject(error);
        });
}
/*
* //Usage
*  RequestTaskExecute("layers":[{"name":"layer name","url": serviceurl}], "type": "validatelayerinfo" }).then(
response => {
if (response){

},
error => {
console.log(error);
});
* config of union task requires serviceurl and type
* resolve resolve of Promise
* reject resolve of reject
*/

function ValidatelayerinfoTaskExecute(esriRequest, config, resolve, reject) {
    try {
        if (config && config.layers) {
            let layersResponses = config.layers.map(function (layerconfig) {
                return new Promise((layerresolve, layerreject) => {
                    ValidateLayerInfoTaskExecuteWrapper(esriRequest, layerconfig, layerresolve, layerreject, "status");
                });
            });
            Promise.all(layersResponses).then(
                response => {
                    resolve(response);
                }, error => {
                    resolve(error);
                });
        }
    } catch (error) {
        //type : correct: type is missing
        config["Message"] = false;
        config["Error"] = error;
        resolve(config);
    }
}


/*
* //Usage
*  RequestTaskExecute("layers":[{"name":"layer name","url": serviceurl}], "type": "validatelayerinfo" }).then(
response => {
if (response){

},
error => {
console.log(error);
});
* config of union task requires serviceurl and type
* resolve resolve of Promise
* reject resolve of reject
*/
function ValidateLayerInfoTaskExecuteWrapper(esriRequest, config, resolve, reject, type) {
    try {
        if (config && config.url) {
            let url = config.url
            if (url.indexOf('/query') !== -1) {
                const urlParts = url.split('/query')
                url = urlParts[0];
            }
            if (type === "info") {
                let url = ParseLayerUrl(config.url, true);
            }
            else if (type === "status") {
                url = url.replace('/query', '/query?where=1%3D1&returnCountOnly=true&f=json').replace('query', '/query?where=1%3D1&returnCountOnly=true&f=json')
                    .replace('/info', '/query?where=1%3D1&returnCountOnly=true&f=json').replace('info', '/query?where=1%3D1&returnCountOnly=true&f=json');
            }
            ValidateLayerInfoTaskExecuteWrapperRequest(esriRequest, config, resolve, reject, type, url, true)
        }
    } catch (error) {
        config[type + "Message"] = false;
        config[type + "Error"] = error;
        resolve(config);
    }
}
function ValidateLayerInfoTaskExecuteWrapperRequest(esriRequest, config, resolve, reject, type, url, isinfo) {
    esriRequest(url).then(
        response => {
            ValidateLayerInfoTaskExecuteWrapperResponse(config, type, response, resolve, reject)
        },
        error => {
            if (type === "info" && isinfo) {
                url = ParseLayerUrl(config.url, false);
                ValidateLayerInfoTaskExecuteWrapperRequest(esriRequest, config, resolve, reject, type, url, false)
            }
            else {
                config[type + "Message"] = false;
                config[type + "Error"] = error;
                resolve(config);
            }
        });
}
function ValidateLayerInfoTaskExecuteWrapperResponse(config, type, response, resolve, reject) {
    let layerInfo = {};
    let esriRequest = '' // correct: esriRequest is missing.compare and correct
    if (type === "status") {
        if (response.data != null && response.data.count >= 0) {
            config.statusMessage = true;
            return new Promise((inforesolve, inforeject) => {
                ValidateLayerInfoTaskExecuteWrapper(esriRequest, config, inforesolve, inforeject, "info").then(
                    inforesponse => {
                        resolve(config);
                    },
                    infoerror => {
                        resolve(config);
                    });
            });
        } else {
            config.statusMessage = false;
            config.statusError = "Layers is down.";
            resolve(config);
        }
    }
    if (type === "info") {
        if (config.name === response.data.name) {
            config.infoMessage = true;
            resolve(config);
        } else {
            config.infoMessage = false;
            config.infoError = "Layers information is changed or misconfigured.";
            resolve(config);
        }
    }
}

//Not using - UNTESTED
export function GeometryProjectionTask(config, geometry) {
    return new Promise((resolve, reject) => {
        loadModules([
            "esri/geometry/geometryEngine",
            "esri/geometry/projection"
        ]).then(([geometryEngine, projection]) => {
            try {
                if (config && config.spatialReference) {
                    //console.log('spatialReference......',config.spatialReference)
                    projection.load().then(res => {
                        projection.project(geometry, config.spatialReference).then(projres => {
                            console.log(projres);
                        })
                    })

                } else {
                    reject({ "error": "Invalid geometries" });
                }
            } catch (error) {
                reject({ "error": error });
            }
        })
    })
}

/*
 * //Usage
 *  GeometryEngineTask({ "geometries": geometries, "type": "union" }).then(
    GeomEngineresponse => {
    if (GeomEngineresponse && GeomEngineresponse.centroid)
    CenterAndZoom(view, GeomEngineresponse.centroid, inThis.props.options.viewProperties.zoom);
    },
    GeomEngineerror => {
    console.log(GeomEngineerror);
    });
 * geometryEngine of esri/geometry/geometryEngine
 * config of union task requires geometries and type
 * resolve resolve of Promise
 * reject resolve of reject
 */
function UnionTaskExecutePointZoom(projection, geometryEngine, config, resolve, reject) {
    try {
        //Check fo not null geoms
        //let configgeom = config.geometries.filter(a => a.geometry != null);
        if (config && config.geometries) {

            GetFeaturePointOnFail(config.geometries).then(res => {
                let union = geometryEngine.union(res);
                if (config.spatialReference)
                    ProjectionTaskExecute(projection, config, union, resolve, reject);
                else
                    resolve(union);
            })
        } else {
            reject({ "error": "Invalid geometries" });
        }
    } catch (error) {
        reject({ "error": error });
    }
}

function GetFeaturePointOnFail(features) {
    return new Promise((resolve, reject) => {
        loadModules([
            "esri/Graphic",
            "esri/geometry/Point"
        ]).then(([Graphic, Point]) => {
            let pointsArr = [];
            features.forEach(element => {
                if(element && element.geometry && element.geometry.latitude){
                    pointsArr.push(new Point({
                        latitude: element.geometry.latitude,
                        longitude: element.geometry.longitude,
                        spatialReference: element.geometry.spatialReference
                    }));
                }                
            });
            resolve(pointsArr);
        })
    })
}


function validateSegmentCount(geometryEngine, config, graphicies, resolve, reject) {
    try {
        if (config.MapBussinessRules && graphicies && config && config.spatialReference && graphicies.length > 1) {
            
            var geomDistanceRules =config.MapBussinessRules.flatMap(businessRule => businessRule.rules && businessRule.rules.filter(rule => 
                rule.fields.indexOf(config.ValidateOf || "TOTAL_GEOMETRY_SEGMENTS_COUNT") !== -1)
                ).filter(businessRule => businessRule);           
            if (geomDistanceRules && Array.isArray(geomDistanceRules) && geomDistanceRules.length > 0) {
                geomDistanceRules.forEach(function (gr) {
                    const checks = gr.check
                    const run = gr.run
                    let rulesResponses = [];
                    if (checks && run && run.events) {
                        checks.forEach(function (check) {
                            if (check && check.rules && check.rules.length > 0) {
                                check.rules.forEach(function (r) {
                                    const rvalue = r.value;
                                    const graphiccount = graphicies.length;
                                    let isValidationFalied = false;
                                    if (r.type === "=") {
                                        isValidationFalied = graphiccount == rvalue
                                    }
                                    else if (r.type === ">") {
                                        isValidationFalied = graphiccount > rvalue
                                    }
                                    else if (r.type === "<") {
                                        isValidationFalied = graphiccount < rvalue
                                    }
                                    else if (r.type === ">=") {
                                        isValidationFalied = graphiccount >= rvalue
                                    }
                                    else if (r.type === "<=") {
                                        isValidationFalied = graphiccount <= rvalue
                                    }
                                    rulesResponses.push({ RuleId: gr.ruleId, IsValidationFalied: isValidationFalied, alertMessage: run.events.alertMessage });                                            
                                    console.log('Distance sketch ------------------', graphiccount)
                                             
                                });
                            }
                        });
                    }
                    resolve(rulesResponses);
                });
            } else {
                resolve([]);
            }
        } else {
            resolve([]);
        }
    } catch (error) {
        reject({ "error": error });
    }
}

function CheckLayerHasAuthentication(url){
    return new Promise((resolve, reject) => {
        fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            if(data && data.error){
                resolve(true);
            }else{
                resolve(false);
            }
        })
        .catch(error => {
            // If the request fails with an authentication error, the layer requires authentication
            if (error.message.includes("499") || error.message.includes("token") || error.message.includes("authentication")) {
                resolve(true);
            } else {
                // If the request fails for another reason, reject the promise
                reject(error);
            }
        });
    })
}

/***
 * 
 * 
 */
function CenterGeometryTaskExecute(projection, geometryEngine, config, resolve, reject) {
    try {
        loadModules([        
            'esri/geometry/Point',   
            'esri/geometry/Polyline',
        ]).then(([Point, Polyline]) => {
            let geometry = config.geometries;
            const type = geometry.type;
            if(type === 'line' || type === 'polyline'){
                let midpoint = calculateGeometricCenter(geometry, Point, geometryEngine);
                if(midpoint)
                    resolve(midpoint);                  
                else
                    resolve(geometry)
            }else if(type === 'point'){
                resolve(geometry)
            }
            else {
                let unionGeomResponse = config.uniongeomEngineResponse;
                if(unionGeomResponse && unionGeomResponse.extent && unionGeomResponse.extent.center){
                    resolve(unionGeomResponse.extent.center)
                }else{
                    var extentcenter = geometry.extent ? geometry.extent.center : geometry;
                    resolve(extentcenter)            
                }                
            }
        })
              
    } catch (error) {
        reject({ "error": error });
    }
}


function calculateGeometricCenter(polyline, Point, geometryEngine) {
    try {        
        const paths = polyline.paths[0];
        let totalLength = 0;
        const segmentLengths = [];

        // Calculate the total length and store segment lengths
        for (let i = 0; i < paths.length - 1; i++) {
        const point1 = new Point({ x: paths[i][0], y: paths[i][1], spatialReference: polyline.spatialReference });
        const point2 = new Point({ x: paths[i + 1][0], y: paths[i + 1][1], spatialReference: polyline.spatialReference });
        const segmentLength = geometryEngine.distance(point1, point2, "meters");
        segmentLengths.push(segmentLength);
        totalLength += segmentLength;
        }

        // Find the mid-length
        const midLength = totalLength / 2;
        let cumulativeLength = 0;

        // Determine which segment contains the mid-length
        for (let i = 0; i < segmentLengths.length; i++) {
            cumulativeLength += segmentLengths[i];
            if (cumulativeLength >= midLength) {
                const previousLength = cumulativeLength - segmentLengths[i];
                const remainingLength = midLength - previousLength;

                // Interpolate to find the mid-point on the segment
                const startPoint = new Point({
                x: paths[i][0],
                y: paths[i][1],
                spatialReference: polyline.spatialReference
                });
                const endPoint = new Point({
                x: paths[i + 1][0],
                y: paths[i + 1][1],
                spatialReference: polyline.spatialReference
                });
                const fraction = remainingLength / segmentLengths[i];

                const midPoint = new Point({
                x: startPoint.x + (endPoint.x - startPoint.x) * fraction,
                y: startPoint.y + (endPoint.y - startPoint.y) * fraction,
                spatialReference: polyline.spatialReference
                });

                return midPoint;
            }
        }

       
    } catch (error) {
        console.log(error)
    }
    
    return null; 
  }

  /**
   * 
   * @param {*} projection 
   * @param {*} config 
   * @param {*} geometry 
   * @param {*} resolve 
   * @param {*} reject 
   */
  function GetGraphicsExtent(projection, geometryEngine, config, resolve, reject) {
    try {
        loadModules([        
            'esri/geometry/Point',   
            'esri/geometry/Polyline',
            "esri/geometry/Extent",
        ]).then(([Point, Polyline, Extent]) => {
            if (config && config.spatialReference && config.geometries) {        
                let xmin = Infinity, ymin = Infinity, xmax = -Infinity, ymax = -Infinity;    
                config.geometries.forEach(graphic => {                  
                    const { x, y } = graphic;
                    xmin = Math.min(xmin, x);
                    ymin = Math.min(ymin, y);
                    xmax = Math.max(xmax, x);
                    ymax = Math.max(ymax, y);
                });            
                var fullExtent = new Extent({
                  xmin, ymin, xmax, ymax,
                  spatialReference: { wkid: config.spatialReference }
                });
                resolve(fullExtent)
            } else {
                reject({ "error": "Invalid geometries" });
            }
        })        
    } catch (error) {
        reject({ "error": error });
    }
}